import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(({ spacing }: Theme) => ({
  container: {
    padding: spacing(0, 16),
    maxWidth: "1140px",
    marginLeft: "auto",
    marginRight: "auto",
    height: "80vh",
    display: "flex",
    alignItems: "center",
    textAlign: "center"
  },
  title: {
    fontWeight: 900,
    lineHeight: "1.2em",
    color: "white"
  },
  imageWrapper: {
    textAlign: "center"
  },
  image: {
    maxWidth: "300px",
    height: "auto"
  }
}));

interface IProps {
  title: string;
  children?: React.ReactNode;
}

export const GlobalError: React.FunctionComponent<IProps> = ({
  title,
  children
}: IProps) => {
  const customClasses = useStyles();

  return (
    <div className={customClasses.container}>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Typography variant="h1" className={customClasses.title} gutterBottom>
            {title}
          </Typography>
          {children}
        </Grid>
      </Grid>
    </div>
  );
};
